import { Injectable } from '@angular/core';
import { routeScheduledTimingRepeat } from '@medlogic/shared/shared-interfaces';
import { FhirGenericService } from './fhir-generic.service';

@Injectable({ providedIn: 'root' })
export class FhirScheduledTimingRepeatService extends FhirGenericService {
  protected url = routeScheduledTimingRepeat;

}
